import { useEffect, useRef, useState } from "react";

export function useLoadingTimeout(isPending: boolean, timeoutMs: number): boolean {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isTimedOut, setIsTimedOut] = useState(false);

  useEffect(() => {
    if (!isPending) {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setIsTimedOut(false);
      return;
    }

    if (timeoutRef.current !== null) {
      return;
    }

    timeoutRef.current = setTimeout(() => {
      setIsTimedOut(true);
    }, timeoutMs);

    return () => {
      if (isPending && timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [isPending, timeoutMs]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return isTimedOut;
}

export function createSessionVerificationTimeoutError(message: string): Error {
  const error = new Error(message);
  error.name = "SessionVerificationError";
  return error;
}
